import { formatBeirutDate, formatHour } from './format';

/** Labels that depend on the selected period: its name, the comparison phrase and the chart's per-bucket label. */
export const describePeriod = (t, windows) => {
  if (windows.id === 'yesterday') {
    return {
      name: t('periodYesterday', 'Yesterday'),
      comparison: t('vsDayBefore', 'vs the day before'),
      bucketTotal: t('thisHour', 'this hour')
    };
  }
  if (windows.id === '7d') {
    return {
      name: t('periodLast7Days', 'Last 7 days'),
      comparison: t('vsPrevious7Days', 'vs the previous 7 days'),
      bucketTotal: t('thisDay', 'this day')
    };
  }
  if (windows.id === 'month') {
    return {
      name: t('periodThisMonth', 'This month'),
      comparison: t('vsSamePointLastMonth', 'vs the same point last month'),
      bucketTotal: t('thisDay', 'this day')
    };
  }
  return {
    name: t('periodToday', 'Today'),
    comparison: t('vsSameTimeYesterday', 'vs the same time yesterday'),
    bucketTotal: t('thisHour', 'this hour')
  };
};

export const bucketLabel = (bucket, language) => (bucket.hour !== undefined
  ? `${formatHour(bucket.hour)}–${formatHour((bucket.hour + 1) % 24)}`
  : formatBeirutDate(bucket.start, language, { weekday: 'short', day: 'numeric', month: 'short' }));

/** Localised name of a direct report's type, plural for section titles. */
export const typeLabel = (t, type, plural = false) => {
  const labels = {
    country: plural ? t('typeCountries', 'Countries') : t('typeCountry', 'Country'),
    city: plural ? t('typeCities', 'Cities') : t('typeCity', 'City'),
    'super-agent': plural ? t('typeSuperAgents', 'Super agents') : t('typeSuperAgent', 'Super agent'),
    agent: plural ? t('typeAgents', 'Agents') : t('typeAgent', 'Agent'),
    player: plural ? t('typePlayers', 'Players') : t('typePlayer', 'Player'),
    admin: t('typeAdmin', 'Admin')
  };
  return labels[type] || type;
};
